import React from 'react';

export const Card = ({ children, className = '', ...props }) => (
  <div className={`bg-white rounded-xl border border-slate-200 shadow-sm ${className}`} {...props}>{children}</div>
);

export const Label = ({ children, className = '' }) => (
  <label className={`block text-sm font-medium text-slate-700 mb-1.5 ${className}`}>{children}</label>
);

export const Input = ({ className = '', ...props }) => (
  <input 
    className={`flex h-10 w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent transition-colors disabled:cursor-not-allowed disabled:opacity-50 ${className}`} 
    {...props} 
  />
);

export const Button = ({ children, variant = 'primary', className = '', ...props }) => {
  const variants = {
    primary: "bg-slate-900 text-white hover:bg-slate-800",
    destructive: "bg-red-500 text-white hover:bg-red-600",
    success: "bg-emerald-600 text-white hover:bg-emerald-700",
    outline: "border border-slate-200 bg-white hover:bg-slate-100 text-slate-900",
  };
  
  return (
    <button 
      className={`inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors disabled:opacity-50 h-10 px-4 ${variants[variant]} ${className}`} 
      {...props}
    >
      {children}
    </button>
  );
};